import { TEMPLATE_LIST, TEMPLATES, getSlotCount, getLayoutSlots } from "@/lib/layouts";
import { Check } from "lucide-react";

/**
 * Visual radio-button grid that renders a mini A4 wireframe for each
 * template. Used in place of a boring text dropdown.
 */
export default function LayoutRadioGrid({ value, onChange, photosPerPage }) {
  return (
    <div
      data-testid="layout-radio-grid"
      className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3"
    >
      {TEMPLATE_LIST.map((id) => {
        const t = TEMPLATES[id];
        const slots = getSlotCount(id, photosPerPage);
        const rects = getLayoutSlots(id, slots);
        const isActive = value === id;
        return (
          <button
            key={id}
            type="button"
            onClick={() => onChange(id)}
            data-testid={`layout-radio-${id}`}
            aria-pressed={isActive}
            className={`group relative text-left p-3 rounded-2xl border-2 transition-all bg-white hover:-translate-y-0.5 ${
              isActive
                ? "border-[#299fe0] shadow-[0_10px_25px_-12px_rgba(41,159,224,0.35)]"
                : "border-slate-200 hover:border-slate-300"
            }`}
          >
            {isActive && (
              <div
                className="absolute -top-2 -right-2 w-6 h-6 rounded-full flex items-center justify-center text-white shadow"
                style={{
                  background: "linear-gradient(135deg,#299fe0,#cb05a5)",
                }}
              >
                <Check size={13} strokeWidth={3} />
              </div>
            )}
            {/* Mini A4 preview */}
            <div className="a4-ratio w-full bg-slate-50 rounded-lg overflow-hidden relative border border-slate-100">
              {rects.map((r, i) => (
                <div
                  key={i}
                  className="absolute"
                  style={{
                    left: r.left,
                    top: r.top,
                    width: r.width,
                    height: r.height,
                    padding: "2px",
                  }}
                >
                  <div
                    className={`w-full h-full rounded-[2px] ${
                      isActive
                        ? "bg-[#299fe0]/25 border border-[#299fe0]/60"
                        : "bg-slate-300/50 border border-slate-300"
                    }`}
                  />
                </div>
              ))}
            </div>
            <div className="mt-2 flex items-baseline justify-between gap-1">
              <div
                className={`text-[11px] font-semibold leading-tight ${
                  isActive ? "text-slate-900" : "text-slate-700"
                }`}
              >
                {t.label}
              </div>
              <div className="text-[10px] font-mono text-slate-400 whitespace-nowrap">
                {slots}
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
}
